import { CommonStatus } from '../../../types/common';
import { CommonActionsType } from './contracts/actionTypes';

export const setCommonStatus = (payload: CommonStatus): any => ({
  type: CommonActionsType.SET_COMMON_STATUS,
  payload
})